export default (str: string, max: number = 70, join: string = '…') => {
    return str.length > max ? str.slice(0, max) + join : str;
};
